export const detectAdBlock = () => {
    let ad = false;

    const adHeader: HTMLElement | null = document.getElementById('AdHeader');
    const aDContainer: HTMLElement | null = document.getElementById('AdContainer');
    const adTop: HTMLElement | null = document.getElementById('AD_Top');
    const homeAd: HTMLElement | null = document.getElementById('homead');
    const adLead: HTMLElement | null = document.getElementById('ad-lead');
    
    if (adHeader || aDContainer || adTop || homeAd || adLead) {
        ad = false
    }

    return ad;
};

